import { Component, input } from '@angular/core';
import type { FormArray, FormControl } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import type { InterviewResultAnswerOption } from '@core/interview-results-types';
import { CheckboxComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-evaluation-multi-choice-field',
  templateUrl: './evaluation-multi-choice-field.component.html',
  styleUrls: ['./evaluation-multi-choice-field.component.less'],
  imports: [ReactiveFormsModule, CheckboxComponent],
})
export class EvaluationMultiChoiceFieldComponent {
  public readonly selections = input.required<FormArray<FormControl<boolean>>>();
  public readonly options = input<InterviewResultAnswerOption[]>([]);
}
